// A Supabase call that has to succeed. Returns its data, or throws saying what
// could not be done and why.
//
// Many billing writes ignored { error } until 2026-10-20: a refused update
// (row-level security, a dropped connection) looked exactly like a saved one,
// and the screen moved on as if it had happened.
export const must = async (query, what) => {
  const { data, error } = await query;
  if (error) throw new Error(`Could not ${what}: ${error.message}`);
  return data;
};
